/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ClientType = {
    Natural: 'Natural',
    Legal: 'Legal'
} as const;
export type ClientType = typeof ClientType[keyof typeof ClientType];


export function ClientTypeFromJSON(json: any): ClientType {
    return ClientTypeFromJSONTyped(json, false);
}

export function ClientTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientType {
    return json as ClientType;
}

export function ClientTypeToJSON(value?: ClientType | null): any {
    return value as any;
}

